{
    "DisplayasoptionsGrid": "Grid",
    "DisplayasoptionsColumns": "Columns",
    "DisplayasoptionsRows": "Rows",
    "DisplayasoptionsChart": "Chart",
    "DisplayasoptionsDetailedtableview": "Detailed Table View",
    "DisplayasoptionsBlfviewhorizontal": "BLF View (Horizontal)",
    "DisplayasoptionsBlfviewvertical": "BLF View (Vertical)",
    "DisplayasoptionsChartview": "Chart View",
    "NAME": "DisplayedAsOptions"
}